import { Component }                      from '@angular/core';
import { MatDialogRef }                    from '@angular/material';
import { Globals }                        from '../common/globals';
import { TrainService } from '../shared/train.service';
import { SettingService } from '../shared/setting.service';

@Component({
  selector: 'sa-setting-dialog',
  template: require('./setting-dialog.component.html'),
  styles: [require('./setting-dialog.component.scss')]
})
export class SettingDialogComponent {
  public model: any;
  public newItem = false;

  public errors = [];
  constructor(
    public dialogRef: MatDialogRef<SettingDialogComponent>,
    public settingService: SettingService,
    public globals: Globals,
    // @Inject(MAT_DIALOG_DATA) private data: {model: HolidayExceptionItemModel},
  ) {
  }

  save() {
    this.errors = [];
    if (this.errors.length === 0) {
      this.dialogRef.close('save');
    }
  }

  delete() {
    if (confirm('Opravdu si přejete odstranit tento záznam?')) {
      this.dialogRef.close('delete');
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/setting-dialog/setting-dialog.component.ts